export const SHIFT_STATUS = {
	CLAIMED: 'Claimed',
	UNCLAIMED: 'Unclaimed',
	CONFIRMED: 'Confirmed',
	ARRIVED: 'Arrived'
};

export const SHIFT_FEATURES = {
	BUNDLES: 'Bundles',
	ORIENTATION: 'Orientation',
	GUARANTEED: 'Guaranteed',
	BONUS: 'Bonus'
};

export const SHIFT_ROUTES = {
	SHIFTMED: 'ShiftMed',
	FLEX: 'Flex',
	HYBRID: 'Hybrid'
};

export const SHIFT_TYPES = {
	ON_DEMAND: 'ON_DEMAND',
	FLEX: 'FLEX',
	HYBRID: 'HYBRID'
};

export const GLOBAL_OVERVIEW_SHIFT_STATUS = {
	FILLED: {
		name: 'Filled',
		isDefault: true
	},
	OPEN: {
		name: 'Open',
		isDefault: true
	},
	CONFIRMED: {
		name: 'Confirmed',
		isDefault: true
	},
	CANCELLED: {
		name: 'Cancelled',
		isDefault: false
	}
};

export const GLOBAL_OVERVIEW_SHIFT_ROUTES = {
	SHIFTMED: {
		name: 'ShiftMed',
		isDefault: true
	},
	FLEX: {
		name: 'Flex',
		isDefault: true
	},
	HYBRID: {
		name: 'Hybrid',
		isDefault: true
	}
};

export default SHIFT_STATUS;
